var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"square-container flex items-center"},[_c('img',{ref:"imageRef",staticClass:"image",attrs:{"src":`${_vm.publicPath}assets/img/logo-bagi.png`,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }